import React from 'react';
import { EVERYONE, memberColor, TEAM } from '../../constants/team';
import './TeamPlan.css';

/** A person's initial in their colour; the whole team as three overlapping ones. */
export function Avatar({ name, size = 22 }) {
  const style = { width: size, height: size, fontSize: Math.round(size * 0.48) };
  if (name === EVERYONE) {
    return (
      <span className="tp-avatars" aria-hidden="true">
        {TEAM.map((m) => (
          <span key={m.name} className="tp-avatar" style={{ ...style, background: m.color }}>{m.name.charAt(0)}</span>
        ))}
      </span>
    );
  }
  if (!name) return <span className="tp-avatar tp-avatar--none" style={style} aria-hidden="true">?</span>;
  return (
    <span className="tp-avatar" style={{ ...style, background: memberColor(name) }} aria-hidden="true">
      {name.charAt(0).toUpperCase()}
    </span>
  );
}

/** The diamond that marks a milestone. */
export function MilestoneIcon() {
  return (
    <svg className="tp-diamond" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M6 0.8 11.2 6 6 11.2 0.8 6z" fill="currentColor" />
    </svg>
  );
}
